import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import app from '../firebase';

const auth = getAuth(app);
const db = getFirestore(app);

export default function LoginAdmin() {
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      const cred = await signInWithEmailAndPassword(auth, email, clave);

      // ✅ Validación REAL de rol admin/superadmin
      const ref = doc(db, 'administradores', cred.user.uid);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        await signOut(auth);
        setError('No tienes permisos de administrador.');
        setCargando(false);
        return;
      }

      const rol = snap.data()?.rol || null;
      const permitido = rol === 'admin' || rol === 'superadmin';

      if (!permitido) {
        await signOut(auth);
        setError('No tienes permisos de administrador.');
        setCargando(false);
        return;
      }

      navigate('/admin');
    } catch (err) {
      setError('Correo o contraseña incorrectos.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '4rem auto', textAlign: 'center' }}>
      <h2>Acceso Administrador</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ display: 'block', margin: '10px auto', width: '100%' }}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          required
          style={{ display: 'block', margin: '10px auto', width: '100%' }}
        />
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" disabled={cargando}>
          {cargando ? 'Verificando...' : 'Ingresar'}
        </button>
      </form>
    </div>
  );
}
